export default window._cmsContent['solar/usage-estimate']